import { render, staticRenderFns } from "./LocationContactForm.vue?vue&type=template&id=23e8b915&scoped=true"
import script from "./LocationContactForm.vue?vue&type=script&lang=js"
export * from "./LocationContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8b915",
  null
  
)

export default component.exports